export default __webpack_public_path__ + "static/media/3022.532a4c4b.jpg";